import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, " Login to your account ", -1);
const _hoisted_2 = {
  class: "email-div"
};
const _hoisted_3 = {
  class: "password-div"
};
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", {
  class: "forgot-text-style"
}, "Forgot password?", -1);
const _hoisted_5 = [_hoisted_4];
const _hoisted_6 = {
  class: "btn-div"
};
const _hoisted_7 = {
  class: "wrong-credential"
};
const _hoisted_8 = {
  key: 0,
  class: "error-message"
};
const _hoisted_9 = {
  class: "btn-row"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_input_v2 = _resolveComponent("app-input-v2");
  const _component_app_button = _resolveComponent("app-button");
  const _component_app_form = _resolveComponent("app-form");
  const _component_the_wrapper_public_v2 = _resolveComponent("the-wrapper-public-v2");
  const _component_IntercomScript = _resolveComponent("IntercomScript");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_the_wrapper_public_v2, null, {
    default: _withCtx(() => [_createVNode(_component_app_form, {
      onSubmit: $options.onSubmit,
      novalidate: ""
    }, {
      default: _withCtx(() => [_hoisted_1, _createElementVNode("div", _hoisted_2, [_createVNode(_component_app_input_v2, {
        hasError: $data.isInvalidCredentials,
        ref: "inputEmail",
        modelValue: $data.form.email,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.form.email = $event),
        validateRule: "email",
        type: "email",
        label: "Email",
        placeholder: "Please enter your email",
        required: "",
        onSubmit: $options.onSubmit
      }, null, 8, ["hasError", "modelValue", "onSubmit"])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = (...args) => $options.recovery && $options.recovery(...args)),
        class: "forgot-password-position"
      }, _hoisted_5), _createVNode(_component_app_input_v2, {
        hasError: $data.isInvalidCredentials,
        ref: "inputPassword",
        modelValue: $data.form.password,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.form.password = $event),
        validateRule: "password",
        type: "password",
        label: "Password",
        placeholder: "Please enter your password",
        description: "Password should contain at least 8 characters (Alphanumeric characters only)",
        required: "",
        onSubmit: $options.onSubmit
      }, null, 8, ["hasError", "modelValue", "onSubmit"])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [$data.isInvalidCredentials ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString($data.errorMessage), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_app_button, {
        loading: $data.loading,
        type: "submit"
      }, {
        default: _withCtx(() => [_createTextVNode("Log in")]),
        _: 1
      }, 8, ["loading"])])])]),
      _: 1
    }, 8, ["onSubmit"])]),
    _: 1
  }), !$data.is_authenticated ? (_openBlock(), _createBlock(_component_IntercomScript, {
    key: 0,
    appId: $data.intercomAppId,
    userName: $data.userName,
    userEmail: $data.userEmail,
    showPopup: !$data.is_authenticated
  }, null, 8, ["appId", "userName", "userEmail", "showPopup"])) : _createCommentVNode("", true)], 64);
}